import api from 'api/config';

/**
 * LiquidTrust Service for global configuration data
 * Provides methods to fetch countries and business types for registration
 */
export const liquidTrustService = {
  /**
   * Get list of supported countries
   * @returns {Promise} Response with countries data
   */
  getCountries: async () => {
    try {
      const response = await api.get('/liquidtrust/countries');
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      console.error('Failed to get countries:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to retrieve countries',
      };
    }
  },

  /**
   * Get business types for a specific country
   * @param {string} countryCode - ISO 3166-1 alpha-2 country code (e.g., "US")
   * @returns {Promise} Response with business types data
   */
  getBusinessTypes: async (countryCode) => {
    try {
      if (!countryCode) {
        return {
          success: false,
          error: 'Country code is required',
        };
      }

      const response = await api.get(
        `/liquidtrust/business-types/${countryCode}`
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      console.error('Failed to get business types:', error);
      return {
        success: false,
        error:
          error.response?.data?.error || 'Failed to retrieve business types',
      };
    }
  },
};

export default liquidTrustService;
